import {Component, OnInit} from '@angular/core';
import {KindService} from "../../service/kind.service";
import {AktionService} from "../../service/aktion.service";
import {AnmeldungStatus} from "../../models/enums";
import {IAnmeldung} from "../../models/IAnmeldung.interface";
import {ElternService} from "../../service/eltern.service";
import {IAktion} from "../../models/IAktion.interface";
import {SUBNAV_SETTNGS} from "../../app-routing.module";

type AgeInfo = {age: string, count: number}

type Stats = {
  anzahl_eltern: number,
  anzahl_kinder: {
    gesamt: number,
    sozialpass: number,
    mit_anmeldungen: number,
    mit_gebucht: number,
    ohne_anmeldungen: number,
    nur_voranmeldungen: number,
    mit_warteliste: number,
    alter: AgeInfo[]
  },
  anzahl_aktionen: {
    gesamt: number,
    aktiv: number,
    inaktiv: number,
    platze_frei: number,
    voll: number,
    belegt_90: number,
    belegt_50: number
    warteliste: number
  },
  anzahl_platze: {
    gesamt: number,
    voranmeldung: number,
    anmeldung: number,
    warteliste: number,
    gebucht: number,
    abgemeldet: number
  },
  geld: {
    bezahlt: number
    rechnungen: number
  },
}


function gebuchtFilter(a: IAnmeldung) {
  return a.status === AnmeldungStatus.GEBUCHT;
}

function gebuchtCount(a: IAktion) {
  return a.anmeldungen.filter(gebuchtFilter).length;
}

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {
  public readonly SUBNAV_SETTNGS = SUBNAV_SETTNGS;
  stats?: Stats;

  constructor(
      private readonly elternService: ElternService,
      private readonly kindService: KindService,
      private readonly aktionService: AktionService
  ) { }

  ngOnInit(): void {
    const aktionen = this.aktionService.getList();
    const kinder = this.kindService.getList();
    const alter = [];

    function addAlter(age: string) {
      const info = alter.find(a => a.age === age);
      if(info) {
        info.count++;
      } else {
        alter.push({age, count: 1});
      }
    }

    kinder.map(k => (Date.now() - k.geburtsdatum) / 1000 / 60 / 60 / 24 / 365.25).forEach(a => {
      let age = Math.floor(a);
      if(age >= 18) {
        addAlter("18+")
      } else {
        addAlter(age + "");
      }
    });

    // Fill missing ages
    const lowestAge = Math.min(...alter.filter(a => a.age !== "18+").map(a => parseInt(a.age)));
    for (let age = lowestAge; age < 18; age++) {
      if (!alter.find(a => a.age === age.toString())) {
        alter.push({age: age.toString(), count: 0});
      }
    }
    if (!alter.find(a => a.age === "18+")) {
      alter.push({age: "18+", count: 0});
    }


    alter.sort((a, b) => {
      if (a.age === "18+") return 1;
      if (b.age === "18+") return -1;
      return parseInt(a.age) - parseInt(b.age);
    });


    this.stats = {
      anzahl_aktionen: {
        gesamt: aktionen.length,
        aktiv: aktionen.filter(a => a.aktiv).length,
        inaktiv: aktionen.filter(a => !a.aktiv).length,
        platze_frei: aktionen.filter(a => a.maxKinder > gebuchtCount(a)).length,
        voll: aktionen.filter(a => a.maxKinder <= gebuchtCount(a)).length,
        belegt_90: aktionen.filter(a =>  a.maxKinder * 0.9 <= gebuchtCount(a)).length,
        belegt_50: aktionen.filter(a => a.maxKinder * 0.5 <= gebuchtCount(a)).length,
        warteliste: aktionen.filter(a => a.anmeldungen.some(a => a.status === AnmeldungStatus.WARTELISTE)).length
      },
      anzahl_eltern: this.elternService.getList().length,
      anzahl_kinder: {
        gesamt: kinder.length,
        sozialpass: kinder.filter(k => !!k.soziPass).length,
        mit_anmeldungen: kinder.filter(k => k.anmeldungen.some(a => a.status === AnmeldungStatus.ANGEMELDET)).length,
        mit_gebucht: kinder.filter(k => k.anmeldungen.some(a => a.status === AnmeldungStatus.GEBUCHT)).length,
        ohne_anmeldungen: kinder.filter(k => k.anmeldungen.length === 0).length,
        nur_voranmeldungen: kinder.filter(k => k.anmeldungen.length > 0 && k.anmeldungen.every(a => a.status === AnmeldungStatus.VORANGEMELDET)).length,
        mit_warteliste: kinder.filter(k => k.anmeldungen.some(a => a.status === AnmeldungStatus.WARTELISTE)).length,
        alter: alter
      },
      anzahl_platze: {
        gesamt: aktionen.map(a => a.maxKinder).reduce((sum, next) => sum + next, 0),
        voranmeldung: aktionen.map(a => a.anmeldungen.filter(an => an.status === AnmeldungStatus.VORANGEMELDET).length).reduce((sum, next) => sum + next, 0),
        anmeldung: aktionen.map(a => a.anmeldungen.filter(an => an.status === AnmeldungStatus.ANGEMELDET).length).reduce((sum, next) => sum + next, 0),
        warteliste: aktionen.map(a => a.anmeldungen.filter(an => an.status === AnmeldungStatus.WARTELISTE).length).reduce((sum, next) => sum + next, 0),
        gebucht: aktionen.map(a => a.anmeldungen.filter(an => an.status === AnmeldungStatus.GEBUCHT).length).reduce((sum, next) => sum + next, 0),
        abgemeldet: aktionen.map(a => a.anmeldungen.filter(an => an.status === AnmeldungStatus.ABGEMELDET).length).reduce((sum, next) => sum + next, 0),
      },
      geld: {
        bezahlt: kinder.map(k => k.bezahlterBetrag).reduce((sum, next) => sum + next, 0),
        rechnungen: kinder.map(k => k.rechnungen.reduce((r1, r2) => r1 === null ? r2 : r1.created < r2.created ? r2 : r1, null)?.betrag || 0).reduce((sum, next) => sum + next, 0),
      }
    }
  }
}
